<template>
    <div
        v-if="goal && goal.domain"
        :class="stack ? '' : 'h-100'"
        class="widget d-flex flex-column justify-content-start align-items-start px-1 px-md-3 py-1 py-md-2 m-1"
    >
        <h6 class="mb-0 text-uppercase">Goal progress</h6>
        <small class="text-muted mb-0"
            ><em>current length: {{ moment(goal.created_at).fromNow(true) }}</em></small
        >
        <hr
            style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
        />
        <div class="mb-2 w-100">
            <div class="w-100 d-flex justify-content-between align-items-center">
                <small class="text-nowrap">0%</small>
                <div class="progress w-75" style="height:0.5rem;">
                    <div
                        class="progress-bar"
                        role="progressbar"
                        :style="
                            `background-color:${goal.domain.color}; width:${
                                milestone00.percentage
                            }%`
                        "
                        :aria-valuenow="milestone00.percentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>
                <small class="text-nowrap">{{ milestone00.days }} days</small>
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center">
                <small class="text-nowrap">25%</small>
                <div class="progress w-75" style="height:0.5rem;">
                    <div
                        class="progress-bar"
                        role="progressbar"
                        :style="
                            `background-color:${goal.domain.color}; width:${
                                milestone25.percentage
                            }%`
                        "
                        :aria-valuenow="milestone25.percentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>
                <small class="text-nowrap">{{ milestone25.days }} days</small>
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center">
                <small class="text-nowrap">50%</small>
                <div class="progress w-75" style="height:0.5rem;">
                    <div
                        class="progress-bar"
                        role="progressbar"
                        :style="
                            `background-color:${goal.domain.color}; width:${
                                milestone50.percentage
                            }%`
                        "
                        :aria-valuenow="milestone50.percentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>
                <small class="text-nowrap">{{ milestone50.days }} days</small>
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center">
                <small class="text-nowrap">75%</small>
                <div class="progress w-75" style="height:0.5rem;">
                    <div
                        class="progress-bar"
                        role="progressbar"
                        :style="
                            `background-color:${goal.domain.color}; width:${
                                milestone75.percentage
                            }%`
                        "
                        :aria-valuenow="milestone75.percentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>
                <small class="text-nowrap">{{ milestone75.days }} days</small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Progress",
    props: ["goal", "stats", "stack"],
    computed: {
        milestone00() {
            return this.milestone(0);
        },
        milestone25() {
            return this.milestone(1);
        },
        milestone50() {
            return this.milestone(2);
        },
        milestone75() {
            return this.milestone(3);
        },
    },
    methods: {
        milestone: function(index) {
            if (["preference_assessment", "cme"].includes(this.goal.tracker_type)) {
                return {
                    days: "N/A",
                    percentage: 0,
                };
            }
            return this.stats.progress_milestones[index];
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
</style>
